import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { FaRegComment, FaRegHeart } from "react-icons/fa";

import { useToast } from "../components/ToastProvider";
import '../css/sr.css';

const SearchByTag = () => {
  const [searchedArticles, setSearchedArticles] = useState([]);
  const navigate = useNavigate();
  const { keyword } = useParams();
  const showToast = useToast();

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [pageInputValue, setPageInputValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  
  // Active tab state
  const [activeTab, setActiveTab] = useState("tag");

  useEffect(() => {
    fetchTagSearchData(1);
  }, [keyword]);

  // Function to fetch tag search data with pagination
  const fetchTagSearchData = async (page) => {
    if (!keyword) return;
    
    setIsLoading(true);
    try {
      const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/searchbytag/by_page`, {
        q: keyword,
        page
      });
      
      setSearchedArticles(data.results);
      setTotalPages(data.pagination.totalPages);
      setCurrentPage(data.pagination.currentPage);
    } catch (error) {
      console.error("Tag search error:", error);
      showToast("태그 검색 중 오류가 발생했습니다.", { type: "error" });
    } finally {
      setIsLoading(false);
    }
  };

  // Handle page navigation
  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) {
      fetchTagSearchData(page);
    }
  };

  // Handle page input change
  const handlePageInputChange = (e) => {
    setPageInputValue(e.target.value);
  };

  // Handle page input submission
  const handlePageInputSubmit = () => {
    const pageNumber = Number.parseInt(pageInputValue);
    if (!isNaN(pageNumber) && pageNumber >= 1 && pageNumber <= totalPages) {
      goToPage(pageNumber);
      setPageInputValue("");
    } else {
      showToast(`페이지 번호는 1에서 ${totalPages} 사이여야 합니다.`, { type: "warn" });
    }
  };

  // Generate page numbers for pagination
  const renderPageNumbers = () => {
    const pageNumbers = [];
    const maxVisiblePages = 5;

    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    const endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <div
          key={i}
          className={`wa-page-number ${currentPage === i ? "active" : ""}`}
          onClick={() => goToPage(i)}
        >
          {i}
        </div>
      );
    }

    return pageNumbers;
  };

  return (
    <>
      <div className="sr-center">
        <div className="sr-line" style={{ marginTop: 15 }}>
          <div className="wa-option-box" style={{ marginBottom: 10 }}>
            <div
              className={`wa-option ${activeTab === "keyword" ? "selected" : ""}`}
              onClick={() => {
                setActiveTab("keyword");
                window.location.href = `/search/${keyword}`;
              }}
            >
              키워드 검색
            </div>
            <div
              className={`wa-option ${activeTab === "tag" ? "selected" : ""}`}
              onClick={() => {
                setActiveTab("tag");
                window.location.href = `/search/tag/${keyword}`;
              }}
            >
              태그 검색
            </div>
          </div>
          
          <div className="wa-card sr-card">
            <h3>#{keyword}</h3>
            <p style={{ fontSize: 12 }}>정확히 일치하는 태그를 가진 글을 검색합니다. 포괄적인 검색은 일반 검색을 이용하세요.</p>
            
            {isLoading ? (
              <div className="loading-indicator">로딩 중...</div>
            ) : searchedArticles.length === 0 ? (
              <div className="no-results">검색 결과가 없습니다.</div>
            ) : (
              <>
                {searchedArticles.map((article) => (
                  <div
                    key={article.id}
                    className="pf-at-box"
                    onClick={() => (window.location.href = "/community/article/" + article.id)}
                  >
                    {article.previewImage && (
                      <div className="cm-card-list-item-thumb wa-thumb">
                        <img src={article.previewImage || "/placeholder.svg"} alt="" />
                      </div>
                    )}
                    <div className="pf-at-main" style={{marginLeft:10}}>
                      <div className="pf-at-title">{article.title}</div>
                      <div className="pf-at-date">{article.date}</div>
                    </div>
                    <div style={{ marginLeft: "auto", display: "flex", gap: 8 }}>
                      <div className="pf-at-ct">
                        <FaRegHeart />
                        {article.like}
                      </div>
                      <div className="pf-at-ct">
                        <FaRegComment />
                        {article.commentCount || 0}
                      </div>
                    </div>
                  </div>
                ))}

                {totalPages > 1 && (
                  <div className="wa-page">
                    {currentPage > 1 && (
                      <div className="wa-page-number prev" onClick={() => goToPage(currentPage - 1)}>
                        이전
                      </div>
                    )}

                    {renderPageNumbers()}

                    {currentPage < totalPages && (
                      <div className="wa-page-number next" onClick={() => goToPage(currentPage + 1)}>
                        다음
                      </div>
                    )}

                    <input
                      className="wa-page-number input"
                      type="number"
                      placeholder="이동할 페이지 번호"
                      value={pageInputValue}
                      onChange={handlePageInputChange}
                      min="1"
                      max={totalPages}
                    />
                    <button className="wa-page-number" onClick={handlePageInputSubmit}>
                      이동
                    </button>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default SearchByTag;